import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
const container = document.getElementById('fatalities-dashboard-container');
const root = ReactDOM.createRoot(
  container as HTMLElement
);
const url = (container?.getAttribute("canonical")) ? container.getAttribute("canonical") : "/";
root.render(
  <React.StrictMode>
    <App url={url!} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
